/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * CanPlayThreeCardDailyGameBase
 * auto generated base class for the model CanPlayThreeCardDailyGameModel.
 */
export const CanPlayThreeCardDailyGameModelBase = ModelBase.named('CanPlayThreeCardDailyGame')
  .props({
    __typename: types.optional(types.literal('CanPlayThreeCardDailyGame'), 'CanPlayThreeCardDailyGame'),
    canPlay: types.union(types.undefined, types.boolean),
    canShare: types.union(types.undefined, types.boolean)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CanPlayThreeCardDailyGameModelSelector extends QueryBuilder {
  get canPlay() {
    return this.__attr('canPlay')
  }
  get canShare() {
    return this.__attr('canShare')
  }
}
export function selectFromCanPlayThreeCardDailyGame() {
  return new CanPlayThreeCardDailyGameModelSelector()
}

export const canPlayThreeCardDailyGameModelPrimitives = selectFromCanPlayThreeCardDailyGame().canPlay.canShare
